<template>
  <div>
    <base-header type class="rsgradient pb-3 pb-1 pt-3 pt-md-5"></base-header>

    <b-card style="margin: 20px">
      <b-card-header header-tag="header" class="p-1" role="tab">
        Retiro de Dinero
      </b-card-header>
      <b-card-body v-if="!model.viewResult">
        <div class="row form-group">
            <div class="col-md-12 text-center">
                <label>¿Cuánto querés retirar?</label> 
            </div>
        </div>  

        <label>Importe</label>
        <vue-numeric
          currency="$"
          v-bind:precision="2"
          decimal-separator="."
          thousand-separator=" "
          v-model="model.importe"
          class="form-control"
          @blur="validateAmount"
        ></vue-numeric>
        <label v-if="!model.hideCredit" class="col-md-12 text-center"
          >De {{ model.formattedCredit }} disponible</label
        >
        <div>
          <div class="row text-left" style="margin-top: 10px">
            <div class="col-md-6">
              <b-button class="btn btn-lg btn-danger" @click="goBack"
                >Volver</b-button
              >
            </div>
            <div class="col-md-6 text-right">
              <save-button text="Retirar" @click="rechargeCard"></save-button>
            </div>
          </div>
        </div>
      </b-card-body>

      <b-card-body v-if="model.viewResult">
        <div class="row">
          <div class="col-md-12 text-center">
            <base-alert :type="resultado.Tipo">
              <span class="alert-inner--icon" style="font-size: 60px;">
                <i :class="resultado.Icono"></i>
              </span><br>
              <span class="alert-inner--text" v-html="resultado.Texto"></span>
            </base-alert>
          </div>          
          <div class="col-md-12" id="btnVolver">
            <div class="row text-center" style="margin-top: 10px">
              <div class="col-md-12">
                <b-button class="btn btn-lg btn-danger" @click="goBack"
                  >Volver</b-button
                >                
              </div>
            </div>
          </div>          
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>

<style>
</style>

<script>
import Vue from "vue";
import vSelect from "vue-select";
Vue.component("v-select", vSelect);
import "vue-select/dist/vue-select.css";
import axiosHelpers from "@/helpers/axiosHelpers";
import notificationHelpers from "@/helpers/notificationHelpers";
import generalHelpers from "@/helpers/generalHelpers";

export default {
  components: {},
  data() {
    return {
      model: {
        credit: 0,
        hideCredit: true,
        formattedCredit: "$0.0",
        importe: "",
        viewResult: false,
      },
      resultado: {
        Texto: "",
        Tipo: "success",
        Icono: "fa fa-fw fa-thumbs-up",
      }
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    rechargeCard() {
      let context = this;

      if (!context.validateAmount()) {
        return;
      } 
      var msg = "";
      var tipo = "";
      var icono = "";
      var req = {
        Amount: context.model.importe,
      };

      axiosHelpers.axiosPost(
        "Mastercard/MastercardCardCashout",
        req,
        this,
        function (data) {
          context.model.viewResult = true;
          if (data.ResponseVM.Result) 
          {
              msg = "Operación realizada con éxito" +
                  "<br/>" + "Se debitaron $" + (parseFloat(context.model.importe).toFixed(2)) + " de tu tarjeta MasterCard hacia tu billetera";
              tipo = "success";
              icono = "fa fa-fw fa-thumbs-up";
              
          }
          else
          {
              msg = "Error al realizar el retiro de dinero" +
                  "<br/>";
              tipo = "danger";
              icono = "fa fa-fw fa-thumbs-down";
          }

          context.resultado = {
                    Texto: msg,
                    Tipo: tipo,
                    Icono: icono,
              };
        }
      );
    },
    validateAmount() {
      let context = this;
      if (context.model.importe <= context.model.credit) {
        return true;
      } 
      else 
      {
        notificationHelpers.showError(
          "Error",
          "El importe es mayor que su saldo",
          context
        );
        return false;
      }
    },
  },
  beforeMount: function () {
    let context = this;
      var req = {};
      axiosHelpers.axiosPost("Mastercard/CardCredit", req, context, function (data) {
        context.model.credit = data.ResponseVM.Credit;
        context.model.hideCredit = false;
        context.model.formattedCredit = data.ResponseVM.formattedCredit;
      });
  }
};
</script>